<template>
    <div class="common-problems">
        <div v-if="this.continue">

            <div id="socialContainer" class="social-container">

                <div class="heading text-center">
                    <h5 class="mb-3">Home Sale Legal Protection™ can save home sellers serious money and stress</h5>
                    <h1>Scott C. saved <span class="green-bold">$19,801.00</span> by using Sellers Shield</h1>
                </div>
                <div class="social-quote">
                    <div class="person-icon">
                        <b-img
                            class="social-headshot"
                            :src="img.headshot"
                            alt="img"
                        />
                    </div>
                    <div class="text quote-text">
                        <span class="big-parenth">"</span>I never dreamed I would be served with legal papers in my
                        driveway. Sellers Shield responded quickly, and within 5 minutes, I was at ease.
                        Don't sign the contract until Sellers Shield is in place.<span class="big-parenth">"</span>
                        <span class="quote-signature">- Scott C, Protected by Sellers Shield</span>
                    </div>
                </div>

            </div>

            <button class="common-areas-continue btn btn-primary mt-4" id="commonAreasContinue"
                    @click="hideCommonProblems">Continue
            </button>

        </div>
        <div v-else>
            <b-row>
                <b-col cols="12">
                    <div class="common-problems-intro">
                        Home Sale Legal Protection protects sellers against <span class="green">ANY</span> legal
                        disputes from the buyer after the sale.
                        Including these <span class="green">33+ common problem areas.</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <p class="text-center font-size-6 mt-4">No home is perfect. We can protect you from lawsuits</p>
                </b-col>
            </b-row>
            <b-row>
                <div>
                    <div>
                        <div class="position-relative">
                            <b-row>
                                <b-col
                                    cols="12"
                                    md="6"
                                    lg="4"
                                    v-for="(item, index)  in badges"
                                    :key="index"
                                >
                                    <div class="list-cell">
                                        <i :class="item.icon"></i>
                                        <span class="cell-label">{{ item.label }}</span>
                                        <span class="check-badge">
                    <i class="fa fa-check"></i>
                  </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12">
                                    <div class="list-fade"></div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="list-cell-full mt-4"><span class="check-badge"><i class="fa fa-check"></i></span>
                            <p>...and much, much more. Home Sale Legal Protection™ protects sellers against ALL lawsuits
                                resulting from the home sale - <span
                                    class="green-bold">no matter what that issue is.</span></p>
                        </div>
                        <div class="mission mt-4 text-center">
                            <b-img
                                class="ss-logo"
                                :src="img.logo"
                                alt="Main Logo"
                            />
                            <h5><b>Our Mission:</b> Stop home sale lawsuits.</h5>
                        </div>
                        <button class="common-areas-continue btn btn-primary" id="continue" @click="changeContinue">
                            Continue
                        </button>
                    </div>
                </div>
            </b-row>


        </div>
    </div>
</template>
<script>
import './CommonProblems.scss';

export default {
    name: 'CommonProblems',
    data: () => ({
        continue: false,
        badges: {
            '1': {'icon': 'fa fa-tint', 'label': 'Roof Leaks'},
            '2': {'icon': 'fa fa-list', 'label': 'Unpermitted Work On Home'},
            '3': {'icon': 'fa fa-shower', 'label': 'Water Penetration'},
            '4': {'icon': 'fa fa-bath', 'label': 'Water Damage'},
            '5': {'icon': 'fa fa-plus', 'label': 'Room Additions & Structural Issues'},
            '6': {'icon': 'fa fa-home', 'label': 'Foundation & Slab Issues'},
            '7': {'icon': 'fa fa-fire', 'label': 'Previous Fires'},
            '8': {'icon': 'fa fa-bolt', 'label': 'Electrical Issues'},
            '9': {'icon': 'fa fa-bath', 'label': 'Interior Plumbing Lines'},
            '10': {'icon': 'fa fa-home', 'label': 'Settling & Movement'},
            '11': {'icon': 'fa fa-chevron-up', 'label': 'Roof Damage'},
            '12': {'icon': 'fa fa-exclamation-triangle', 'label': 'Construction Defects'},
            '13': {'icon': 'fa fa-tint', 'label': 'Flooding'},
            '14': {'icon': 'fa fa-window-minimize', 'label': 'Gas Fixtures'},
            '15': {'icon': 'fa fa-bolt', 'label': 'Interior Electrical Lines'},
            '16': {'icon': 'fa fa-bug', 'label': 'Termite Related Issues'},
            '17': {'icon': 'fa fa-tint', 'label': 'Gas Lines'},
            '18': {'icon': 'fa fa-shower', 'label': 'Exterior Plumbing Lines'},
            '19': {'icon': 'fa fa-bolt', 'label': 'Electrical Systems & Accessories'},
            '20': {'icon': 'fa fa-exclamation-triangle', 'label': 'Failed Inspections'},
            '21': {'icon': 'fa fa-fire', 'label': 'Fire Damage'},
            '22': {'icon': 'fa fa-snowflake', 'label': 'Bursted Pipes'},
            '23': {'icon': 'fa fa-fire-extinguisher', 'label': 'Grease Fires'},
            '24': {'icon': 'fa fa-chevron-up', 'label': 'Roof/Attic Vents'},
            '25': {'icon': 'fa fa-user-secret', 'label': 'Low Quality Contractors'},
            '26': {'icon': 'fa fa-tree', 'label': 'Tree & Limb Hazards'},
            '27': {'icon': 'fa fa-bolt', 'label': 'Electrical Hazards'},
            '28': {'icon': 'fa fa-map-signs', 'label': 'Wrong Information'},
            '29': {'icon': 'fa fa-bug', 'label': 'Bug Infestation'},
            '30': {'icon': 'fa fa-th', 'label': 'Flooring'},
            '31': {'icon': 'fa fa-fire', 'label': 'Fireplace & Chimney'},
            '32': {'icon': 'fa fa-cogs', 'label': 'Mechanical Issues'},
            '33': {'icon': 'fa fa-paw', 'label': 'Pet Damages'},
            '34': {'icon': 'fa fa-bars flip-90', 'label': 'Gates & Fences'},
            '35': {'icon': 'fa fa-fire', 'label': 'Range & Stove'},
            '36': {'icon': 'fa fa-snowflake', 'label': 'Air Conditioning & Cooling Systems'},
        },

        img: {
            headshot: require('@assets/images/headshot.png'),
            logo: require('@assets/images/ss-logo-white-bg.png'),
        },
    }),
    methods: {
        hideCommonProblems() {
            this.$emit('hide-common-problems');
        },
        changeContinue() {
            this.continue = true;
        }
    },
}
</script>